import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const LocalImage = ({ filename, alt = '', loading = 'lazy', ...props }) => {
  const { localimages } = useStaticQuery(
    graphql`
      query {
        localimages: allFile(filter: { relativeDirectory: { eq: "newsbox" } }) {
          nodes {
            name
            childImageSharp {
              gatsbyImageData(
                height: 300
                width: 300
                placeholder: TRACED_SVG
                formats: [WEBP, AVIF]
                layout: CONSTRAINED
              )
            }
          }
        }
      }
    `,
  )

  const image = localimages.nodes.find(node => node.name === filename)

  if (!image) {
    return null
  }

  return <GatsbyImage alt={alt} image={getImage(image)} loading={loading} />
}

export default LocalImage
